import React from "react";
import items from "../css/items.css";
import {Link} from "react-router-dom";

export default function Items(props) {
  return (
    <div style={items} className="items">
      <Link to={`/product/${props.id}`}>
        <img onClick={window.scrollTo(0, 0)} src={props.image} alt="" />
      </Link>
      <p>{props.name}</p>
      <div className="items-prices">
        <div className="items-prices-new">${props.new_price}</div>
        <div className="items-prices-old">${props.old_price}</div>
      </div>
    </div>
  );
}
